import { ReferenceLine } from 'recharts';

export function countYAxisReferenceGridLines(
  ticks: number[],
  stroke: string,
  excludeYValues: number[] = []
) {
  const excludeSet = new Set(excludeYValues);
  return ticks
    .filter((tick) => !excludeSet.has(tick))
    .map((tick) => (
      <ReferenceLine
        key={`count-y-grid-${tick}`}
        y={tick}
        stroke={stroke}
        strokeDasharray="3 3"
        ifOverflow="extendDomain"
      />
    ));
}
